export enum IntroductionFeaturesEnum {
	MandatesOverview = 'MandatesOverview',
	NewDashboard = 'NewDashboard',
	MandatesLanding = 'MandatesLanding'
}

export type IntroductionFeaturesKeys = keyof typeof IntroductionFeaturesEnum;
